<template>
  <div class="sub-mod" :class="[h5Options.row === 1 ? 'row1' : h5Options.row === 2 ? 'row2' : 'row3']">
    <div class="mod-hd" v-if="h5Options.title">{{h5Options.title}}</div>
    <div class="mod-bd" :class="{'flex flex-wrap justify-around': h5Options.row !== 1}">
      <sub-list-item
          v-for="item in list"
          :key="item.activityId"
          :item="item"
          :h5-options="h5Options"
      >
      </sub-list-item>
    </div>
  </div>
</template>

<script>
  import SubListItem from './SubListItem'

  export default {
    name: 'SubList',
    props: {
      list: {
        type: Array,
        default () {
          return []
        }
      },
      h5Options: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    components: {
      SubListItem
    }
  }
</script>

<style lang="less">
  .sub-mod {
    padding-top: .26rem;
    .mod-hd {
      font-size: .34rem;
      margin: 0 auto 0.2rem;
      text-align: center;
      color: #fff;
      line-height: .48rem;
    }
    .mod-bd {
      padding: 0 .25rem;
      .item {
        width: 7rem;
        margin-bottom: .16rem;
        border-radius: .1rem;
        background: #fff;
        .img {
          width: 3.6rem;
          height: 1.66rem;
          overflow: hidden;
          border-radius: 0.1rem 0 0 0.1rem;
          img {
            width: inherit;
            height: inherit;
            object-fit: cover;
            display: block;
          }
        }
        .info {
          width: 3.4rem;
          .title {
            padding: .25rem .12rem 0;
            line-height: 1;
            font-size: .24rem;
            font-weight: normal;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .pwd {
            display: block;
            width: 100%;
            height: 0.5rem;
            padding: 0.12rem 0;
            text-align: center;
            font-size: 0.22rem;
            color: #575757;
          }
          .btns {
            padding: 0 0.12rem .15rem;
            button {
              display: block;
              height: .46rem;
              margin: 0 .05rem;
              border-radius: .23rem;
              padding: 0 0.2rem;
              font-size: 0.26rem;
              color: #fff;
              background: #F93501;
            }
          }
        }
      }
    }
    &.row2 {
      .mod-bd {
        padding: 0 .12rem;
      }
      .item {
        width: 3.4rem;
        .img {
          width: 3.4rem;
          height: 1.4rem;
          border-radius: .1rem .1rem 0 0;
        }
        .info {
          width: 100%;
          .title {
            padding: 0 .12rem;
            line-height: .5rem;
          }
          .pwd {
            margin-bottom: .16rem;
            background: #f8f8f8;
          }
          .btns {
            padding: 0 .12rem .15rem;
            button {
              width: 100%;
              margin: 0 .05rem;
            }
          }
        }
      }
    }
    &.row3 {
      .mod-bd {
        padding: 0 .12rem;
      }
      .item {
        width: 2.18rem;
        .img {
          width: 2.18rem;
          height: 1.14rem;
          border-radius: .1rem .1rem 0 0;
        }
        .info {
          width: 100%;
          .title {
            padding: 0 .12rem;
            line-height: .5rem;
          }
          .pwd {
            margin-bottom: .16rem;
            background: #f8f8f8;
          }
          .btns {
            padding-bottom: 0;
            button {
              width: 100%;
              margin: 0 0 .15rem;
            }
          }
        }
      }
    }
  }
</style>
